import React, { FC, useState } from 'react';
import { Link } from 'react-router-dom';
import { NavigationPath } from '~/core/dto/navigationDTO';
import instagram from '~/assets/icons/Instagram.svg';
import tiktok from '~/assets/icons/Tiktok.svg';
import linkedin from '~/assets/icons/Linkedin.svg';
import telegram from '~/assets/icons/Telegram.svg';
import { HeaderProps } from '~/core/dto/components/headerDTO';

import './Header.styles.css';
import Spacer from '../Spacer';

const Header: FC<HeaderProps> = ( { type, top = 0 } ) => {

  const [ isOpened, setIsOpened ] = useState( false );

  return (
    <div>
      <header className="flexRow justifySpaceBetween alignCenter">
        <Link to={type === 'adult' ? NavigationPath.AdultHome : NavigationPath.Home} className="birdwingoTitle">BIRDWINGO</Link>
        <div
          className={`cursorPointer hamburgerMenu${isOpened ? ' active' : ''}`}
          onClick={() => setIsOpened( !isOpened )}
          aria-hidden
        >
          <div className="hamburgerMenuItem" />
          <div className="hamburgerMenuItem" />
        </div>
      </header>
      <footer className={`${isOpened ? ' active' : ''}`}>
        <div className="containerPadding">
          <Spacer size={top} />
          <h2 className="footerTitle">Social networks</h2>
          <ul className="socialNetworks">
            <li>
              <a href="https://www.instagram.com/birdwingo/" target="_blank" rel="noreferrer">
                <img src={instagram} alt="Instagram" />
              </a>
            </li>
            <li>
              <a href="https://www.tiktok.com/@birdwingo" target="_blank" rel="noreferrer">
                <img src={tiktok} alt="TikTok" />
              </a>
            </li>
            <li>
              <a href="https://www.linkedin.com/company/birdwingo/" target="_blank" rel="noreferrer">
                <img src={linkedin} alt="LinkedIn" />
              </a>
            </li>
            <li>
              <a href="https://t.me/+SBdfR1Ajbc01MWM0" target="_blank" rel="noreferrer">
                <img src={telegram} alt="Telegram" />
              </a>
            </li>
          </ul>
          <h2 className="footerTitle">Resources</h2>
          <ul className="resources">
            <li>
              <a href="https://www.birdwingo.com/wp-content/uploads/2023/09/Birdwingo-TCs.pdf" target="_blank" rel="noreferrer">
                Terms of service
              </a>
            </li>
            <li>
              <a href="https://www.birdwingo.com/wp-content/uploads/2022/10/Birdwingo_Privacy-Policy-Updated.pdf" target="_blank" rel="noreferrer">
                Privacy policy
              </a>
            </li>
          </ul>
          <h2 className="footerTitle">Contact us</h2>
          <a href="mailto:hello@birdwingo.com" className="mailToHello">hello@birdwingo.com</a>
        </div>
        <div className="footerText">
          <p>
            Tatrym Inc. 251 Little Falls Drive. New Castle County, Wilmington, Delaware 19808, US.
            &#160;
            <a href="https://www.birdwingo.com/wp-content/uploads/2022/10/Birdwingo_Privacy-Policy-Updated.pdf" target="_blank" rel="noreferrer">Terms & Conditions</a>
            .
            &#160;
            <a href="https://www.birdwingo.com/wp-content/uploads/2023/09/Birdwingo-TCs.pdf" target="_blank" rel="noreferrer">Privacy Policy</a>
          </p>
        </div>
      </footer>
    </div>
  );

};

export default Header;
